import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatBotConversationComponent } from './components/chat/chat-bot-conversation/chat-bot-conversation.component';
import { ChatLeftPanelComponent } from './components/chat/chat-left-panel/chat-left-panel.component';
import { TextComponent } from './components/text.component';
import { ChatTableComponent } from './components/table.component';
import { DynamicLoaderComponent } from './components/dynamic-loader.component';
import { ChatPromptsPanelComponent } from './components/chat/chat-prompts-panel/chat-prompts-panel.component';
import { ChatPromptsComponent } from './components/chat/chat-prompts/chat-prompts.component';
import { ChatBotHeaderComponent } from './components/chat/chat-bot-header/chat-bot-header.component';
import { SpinnerLoadingIndicatorComponent, TableComponent } from '@cbre/components';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TranslationModule } from '@miq/utils';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { ChatInputComponent } from './components/chat/chat-input/chat-input.component';

@NgModule({
  declarations: [
    ChatInputComponent,
    ChatBotHeaderComponent,
    ChatBotConversationComponent,
    ChatLeftPanelComponent,
    TextComponent,
    ChatTableComponent,
    DynamicLoaderComponent,
    ChatPromptsPanelComponent,
    ChatPromptsComponent,
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    MatTableModule,
    MatTabsModule,
    MatPaginatorModule,
    TranslationModule,
    TableComponent,
    FormsModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    SpinnerLoadingIndicatorComponent,
  ],
  exports: [
    ChatInputComponent,
    ChatBotHeaderComponent,
    ChatBotConversationComponent,
    ChatLeftPanelComponent,
    TextComponent,
    ChatTableComponent,
    DynamicLoaderComponent,
    ChatPromptsPanelComponent,
    ChatPromptsComponent,
  ],
})
export class DigitalAssistantSharedModule {}
